export function getViewedMailboxAddress(sharedMailboxAddress?: string): string {
  return (
    sharedMailboxAddress || Office.context.mailbox.userProfile.emailAddress
  );
}
